// Filter report data
export const filterReportData = (reportData, reportFields) => {
  const filteredData = reportData.map(data => {
    delete data.__typename;

    data.mall_name = data?.mall_name.toUpperCase();

    // Filters object to remove extra column
    const erase = Object.keys(data).filter(
      e => !Object.keys(reportFields).includes(e)
    );

    // Deletes here
    for (const i in erase) {
      if ({}?.hasOwnProperty.call(erase, i)) {
        delete data[`${erase[i]}`];
      }
    }
    return data;
  });

  return filteredData;
};
